module.exports = __webpack_public_path__ + "static/media/gerenciamento-de-pessoas.ca98b653.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/gerenciamento-de-pessoas.jpg
// module id = 833
// module chunks = 0